import { api } from '.'

export const fetchUser = () =>
  api.get('/v1/user-info').then(({ data }) => data.data)

export const fetchSlackUrl = () =>
  api.get('/v1/auth/slack-url').then(({ data }) => data)

export const fetchTokenUrl = () => api.get('/v1/token').then(({ data }) => data)
